import React from "react";
import { useParams } from "react-router-dom";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetGeneralLedgerByIdQuery } from "store/services/generalLedgerApi";
import GeneralLedgerBasicDetail from "./GeneralLedgerBasicDetail";
import { Divider } from "@mui/material";

const GeneralLedgerDetailScreen = () => {
  const { id } = useParams();
  const {
    data: generalLedgerDetail,
    isLoading,
    error,
  } = useGetGeneralLedgerByIdQuery(id);

  const breadcrumbs = [
    { title: "General Ledger", path: "/app/crm/general-ledger/list" },
    { title: "General Ledger Detail" },
  ];

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <GeneralLedgerBasicDetail
          generalLedgerDetail={generalLedgerDetail}
          isLoading={isLoading}
        />
        <Divider />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default GeneralLedgerDetailScreen;